import { Injectable } from '@angular/core';
import { CDN_IMAGES } from '../../../constants/param-constants';

@Injectable({providedIn: 'root'})
export class FaqProvider {

  constructor() {
  }

  static getFaqs() {
    return [
      {
        question: {
          mobile: `What will I learn inside Chuck Norris’s Free Business Training Video?`,
          desktop: `What will I learn inside Chuck Norris’s Free Business Training Video?`
        },
        answer: {
          mobile: `
          <p>The biggest mistake entrepreneurs make — and how to avoid it</p>
          <p>The simple mindset shift that unlocks faster growth</p>
          <p>How Robert spots a winning business instantly</p>
          <p>The #1 thing to focus on to move your business forward</p>
          <p>How to find hidden opportunities you’re overlooking</p>
          <p>What successful founders do differently from everyone else</p>
          `,
          desktop: `
          <p>The biggest mistake entrepreneurs make — and how to avoid it</p>
          <p>The simple mindset shift that unlocks faster growth</p>
          <p>How Robert spots a winning business instantly</p>
          <p>The #1 thing to focus on to move your business forward</p>
          <p>How to find hidden opportunities you’re overlooking</p>
          <p>What successful founders do differently from everyone else</p>
          `
        }
      }
    ];
  }
}

